module.exports = __webpack_public_path__ + "static/media/Shopcart.38af1a81.png";